import React, { useEffect, useMemo, useState } from 'react';
import { FiArrowLeft, FiPrinter, FiInfo, FiX } from 'react-icons/fi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getBatchQrCodes } from '../services/api';

const publicLandingUrl =
  process.env.REACT_APP_PUBLIC_LANDING_URL || 'https://loyalty.sailabrasive.com/';

const buildQrDestination = (value: string) => `${publicLandingUrl}?qr=${encodeURIComponent(value)}`;

const buildQrImageUrl = (value: string, size = 260) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=10&data=${encodeURIComponent(buildQrDestination(value))}`;

const QrLabelPrintPage: React.FC = () => {
  const { batchNumber = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [codes, setCodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [referenceImage, setReferenceImage] = useState<string | null>(null);

  const batch = (location.state as any)?.batch;

  useEffect(() => {
    const loadCodes = async () => {
      try {
        const res = await getBatchQrCodes(batchNumber);
        setCodes(res.data.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadCodes();
  }, [batchNumber]);

  const printableCodes = useMemo(
    () => codes.filter((code) => code.qrUuid),
    [codes]
  );

  return (
    <div className="page-container">
      <div className="qr-label-page-header no-print">
        <div>
          <h1>QR Label Print</h1>
          <p>
            Batch <strong>{batchNumber}</strong>
            {batch?.productName ? ` • ${batch.productName}` : ''}
            {typeof batch?.quantity === 'number' ? ` • ${batch.quantity} labels` : ''}
          </p>
        </div>
        <div className="qr-label-page-actions">
          <button className="btn btn-outline" onClick={() => setReferenceImage('/print_references/Printer_Paper_Layout.jpeg')}>
            <FiInfo /> Printer Paper Layout
          </button>
          <button className="btn btn-outline" onClick={() => setReferenceImage('/print_references/QR_Code_Browser_Setting.png')}>
            <FiInfo /> Browser Print Settings
          </button>
          <button className="btn btn-outline" onClick={() => navigate(-1)}>
            <FiArrowLeft /> Back
          </button>
          <button className="btn btn-primary" onClick={() => window.print()}>
            <FiPrinter /> Print Labels
          </button>
        </div>
      </div>

      {loading ? (
        <div className="card">
          <div className="loading">Loading labels...</div>
        </div>
      ) : (
        <div className="qr-label-sheet">
          {printableCodes.map((code: any, index: number) => (
            <div className="qr-label-card" key={code.qrId || code.qrUuid}>

              <div className="qr-label-brand">LANCER Loyalty</div>
              <img
                className="qr-label-image"
                src={buildQrImageUrl(code.qrUuid)}
                alt={`QR ${code.qrUuid}`}
              />
              <div className="qr-label-value">{code.qrUuid}</div>
              <div className="qr-label-caption">
                Scan and enter code to get rewards.
              </div>
              <div className="qr-label-caption2">
                For assistance, please call 18003090520
              </div>
            </div>
          ))}
        </div>
      )}

      {referenceImage && (
        <div className="modal-overlay no-print" onClick={() => setReferenceImage(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
            <div className="modal-header">
              <h3>Print Setting Reference</h3>
              <button className="modal-close" onClick={() => setReferenceImage(null)}>
                <FiX />
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <img src={referenceImage} alt="Reference" style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }} />
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setReferenceImage(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QrLabelPrintPage;
